/**
 * @generated SignedSource<<9a35a589514d9691c04befe91526f69b>>
 * @relayHash b2eeb0cf48e639dc2a009682da32ff2e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID afb5b93e354d2e453248649cca26d11973fa9a96e9254c7a588ade0937e3eab7

import type { ConcreteRequest } from 'relay-runtime';
export type queryAgentMentionsForInitialStateQuery$variables = {
  cloudId: string;
  first?: number | null;
  includeMyAgents: boolean;
  product?: string | null;
};
export type queryAgentMentionsForInitialStateQuery$data = {
  readonly allAgents: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly description: string | null;
        readonly id: string;
        readonly identityAccount: {
          readonly picture: AGG$URL;
        } | null;
        readonly identityAccountId: string | null;
        readonly name: string | null;
      } | null;
    }>;
  } | null;
  readonly favoriteAgents: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly description: string | null;
        readonly id: string;
        readonly identityAccount: {
          readonly picture: AGG$URL;
        } | null;
        readonly identityAccountId: string | null;
        readonly name: string | null;
      } | null;
    }>;
  } | null;
  readonly myAgents?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly description: string | null;
        readonly id: string;
        readonly identityAccount: {
          readonly picture: AGG$URL;
        } | null;
        readonly identityAccountId: string | null;
        readonly name: string | null;
      } | null;
    }>;
  } | null;
  readonly verifiedAgents: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly description: string | null;
        readonly id: string;
        readonly identityAccount: {
          readonly picture: AGG$URL;
        } | null;
        readonly identityAccountId: string | null;
        readonly name: string | null;
      } | null;
    }>;
  } | null;
};
export type queryAgentMentionsForInitialStateQuery = {
  response: queryAgentMentionsForInitialStateQuery$data;
  variables: queryAgentMentionsForInitialStateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeMyAgents"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "product"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v3 = {
  "kind": "Variable",
  "name": "product",
  "variableName": "product"
},
v4 = [
  (v1/*: any*/),
  (v2/*: any*/),
  {
    "kind": "Literal",
    "name": "input",
    "value": {
      "onlyFavouriteAgents": true
    }
  },
  (v3/*: any*/)
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "description"
},
v7 = {
  "kind": "ScalarField",
  "name": "picture"
},
v8 = {
  "kind": "ScalarField",
  "name": "identityAccountId"
},
v9 = {
  "kind": "ScalarField",
  "name": "name"
},
v10 = [
  {
    "concreteType": "AgentStudioAgentEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "AgentStudioAssistant",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "LinkedField",
            "name": "identityAccount",
            "plural": false,
            "selections": [
              (v7/*: any*/)
            ]
          },
          (v8/*: any*/),
          (v9/*: any*/)
        ]
      }
    ]
  }
],
v11 = [
  (v1/*: any*/),
  (v2/*: any*/),
  {
    "kind": "Literal",
    "name": "input",
    "value": {
      "onlyMyAgents": true
    }
  },
  (v3/*: any*/)
],
v12 = [
  (v1/*: any*/),
  (v2/*: any*/),
  {
    "kind": "Literal",
    "name": "input",
    "value": {
      "onlyVerifiedAgents": true
    }
  },
  (v3/*: any*/)
],
v13 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/)
],
v14 = [
  {
    "concreteType": "AgentStudioAgentEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "AgentStudioAssistant",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "LinkedField",
            "name": "identityAccount",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v7/*: any*/),
              (v5/*: any*/)
            ]
          },
          (v8/*: any*/),
          (v9/*: any*/)
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "queryAgentMentionsForInitialStateQuery",
    "selections": [
      {
        "alias": "favoriteAgents",
        "args": (v4/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v10/*: any*/)
      },
      {
        "condition": "includeMyAgents",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "myAgents",
            "args": (v11/*: any*/),
            "concreteType": "AgentStudioAgentsConnection",
            "kind": "LinkedField",
            "name": "agentStudio_getAgents",
            "plural": false,
            "selections": (v10/*: any*/)
          }
        ]
      },
      {
        "alias": "verifiedAgents",
        "args": (v12/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v10/*: any*/)
      },
      {
        "alias": "allAgents",
        "args": (v13/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v10/*: any*/)
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "queryAgentMentionsForInitialStateQuery",
    "selections": [
      {
        "alias": "favoriteAgents",
        "args": (v4/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v14/*: any*/)
      },
      {
        "condition": "includeMyAgents",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "myAgents",
            "args": (v11/*: any*/),
            "concreteType": "AgentStudioAgentsConnection",
            "kind": "LinkedField",
            "name": "agentStudio_getAgents",
            "plural": false,
            "selections": (v14/*: any*/)
          }
        ]
      },
      {
        "alias": "verifiedAgents",
        "args": (v12/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v14/*: any*/)
      },
      {
        "alias": "allAgents",
        "args": (v13/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v14/*: any*/)
      }
    ]
  },
  "params": {
    "cacheID": "b2eeb0cf48e639dc2a009682da32ff2e",
    "id": "afb5b93e354d2e453248649cca26d11973fa9a96e9254c7a588ade0937e3eab7",
    "metadata": {},
    "name": "queryAgentMentionsForInitialStateQuery",
    "operationKind": "query",
    "text": "query queryAgentMentionsForInitialStateQuery($cloudId:String!,$first:Int,$includeMyAgents:Boolean!,$product:String){favoriteAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,input:{onlyFavouriteAgents:true},product:$product)@optIn(to:\"AgentStudio\"){edges{node{id,description,identityAccount{__typename,picture,id},identityAccountId,name}}},myAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,input:{onlyMyAgents:true},product:$product)@include(if:$includeMyAgents)@optIn(to:\"AgentStudio\"){edges{node{id,description,identityAccount{__typename,picture,id},identityAccountId,name}}},verifiedAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,input:{onlyVerifiedAgents:true},product:$product)@optIn(to:\"AgentStudio\"){edges{node{id,description,identityAccount{__typename,picture,id},identityAccountId,name}}},allAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,product:$product)@optIn(to:\"AgentStudio\"){edges{node{id,description,identityAccount{__typename,picture,id},identityAccountId,name}}}}"
  }
};
})();

(node as any).hash = "0a100ab1ba01b559d511e874c261464b";

export default node;
